var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraSlashSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    fill: "#64748b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    d: "m11.2 20.5c1.6 0.7 2.8 1.9 4 2.9q15.9 12.4 31.7 24.8c1.1 0.9 2.2 1.3 3.6 1.3q5.4-0.2 10.9 0c1.3 0 1.9-0.4 2.3-1.7 1-3.1 1.8-6.3 3.1-9.3 2.7-5.7 7.4-8.7 13.6-8.9 5.1-0.2 10.2-0.2 15.3 0.2 3.3 0.3 6.6-0.1 9.9-0.2 4.3-0.1 8.6-0.1 12.8-0.1 7 0 12.6 4.1 14.9 10.7 0.9 2.6 1.8 5.1 2.5 7.7 0.4 1.2 0.9 1.6 2.1 1.6 6.8-0.1 13.6 0 20.4-0.1 5.5 0 10.5 1.5 14.7 5.4q5.6 5.1 6.5 12.7c0.3 3 0.2 6 0.2 9q0 35.3 0 70.7c0 1.3 0.1 2.7-0.2 4-0.2 0.8 0.2 1.3 0.9 1.8q7.6 5.9 15.3 11.8c1.3 1 2.4 2.1 3.2 3.6 1.3 2.6 0.8 6.2-1.2 8.3-2.3 2.4-5.5 3.2-8.4 2q-1.9-0.8-3.5-2.1-28.8-22.6-57.6-45.1-36.2-28.4-72.5-56.8-24-18.9-48.1-37.7c-1.6-1.3-3.3-2.5-4.9-3.9-2.1-1.8-3.3-4.2-2.7-7 0.6-3.3 2.4-5.6 5.7-6.4 1.9-0.4 3.7-0.1 5.5 0.8zm88.6 69.1c9.6 7.6 19.3 15.2 29.1 22.9 1.5-6.3-0.9-19-11-26.8-8.8-6.8-22.1-7.3-28.3-4 3.4 2.6 6.7 5.2 10.2 7.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    d: "m59.2 95.9c3.4 2.7 6.8 5.3 10.2 7.9 0.6 0.6 0.8 1.1 0.7 2-1 13.2 5 25.3 18 30.8 6.7 2.9 13.7 3.4 20.8 0.9 1.4-0.5 2.5-0.4 3.8 0.6 12.6 10 25.3 20 38 30 0.3 0.2 0.8 0.4 0.8 0.9-0.4 0.4-1 0.2-1.5 0.2q-54.8 0-109.6 0c-10.4 0-18.7-7.1-20.3-17.3q-0.3-2-0.3-4-0.1-38.7-0.1-77.4c0-1.7 0.2-3.4 0.5-5.3 13.1 10.3 26 20.4 39 30.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSlashSolid);
export default __webpack_public_path__ + "static/media/camera-slash-solid.409bd3009765051589794554e36e2d92.svg";
export { ForwardRef as ReactComponent };